<template>
	<div class="event-list-item-match">
		<div class="event-list-item-match__team -home">
			<div class="event-list-item-match__team-name -full">
				{{ homeNameFull }}
			</div>
			<div class="event-list-item-match__team-name -short">
				{{ homeName }}
			</div>
			<div class="event-list-item-match__team-logo">
				<img
					v-if="homeImgUrl"
					:src="$Helpers.getScaledImageUrl(homeImgUrl, 50)"
					:alt="homeNameFull"
				>
			</div>
		</div>
		<div class="event-list-item-match__score">
			{{ noSpoilerMode ? '-' : homeScoreWithFallback }}<span class="event-list-item-match__score-divider-space" />{{ dashScoreDevider ? '-' : ':' }}<span class="event-list-item-match__score-divider-space" /><span
				class="event-list-item-match__score-extra"
				:data-extra="noSpoilerMode ? '' : scoreExtraAbbr"
			>{{ noSpoilerMode ? '-' : guestScoreWithFallback }}</span>
		</div>
		<div class="event-list-item-match__team -guest">
			<div class="event-list-item-match__team-logo">
				<img
					v-if="guestImgUrl"
					:src="$Helpers.getScaledImageUrl(guestImgUrl, 50)"
					:alt="guestNameFull"
				>
			</div>
			<div class="event-list-item-match__team-name -full">
				{{ guestNameFull }}
			</div>
			<div class="event-list-item-match__team-name -short">
				{{ guestName }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:  'EventListItemMatchContent',
	props: {
		homeName: {
			type:    String,
			default: null,
		},
		homeNameFull: {
			type:    String,
			default: null,
		},
		homeImgUrl: {
			type:    String,
			default: null,
		},
		homeScoreWithFallback: {
			type:    String,
			default: '',
		},
		guestName: {
			type:    String,
			default: null,
		},
		guestNameFull: {
			type:    String,
			default: null,
		},
		guestImgUrl: {
			type:    String,
			default: null,
		},
		guestScoreWithFallback: {
			type:    String,
			default: '',
		},
		scoreExtraAbbr: {
			type:    String,
			default: null,
		},
		noSpoilerMode: {
			type:    Boolean,
			default: false,
		},
		dashScoreDevider: {
			type:    Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

$result-width: 60px;
$result-width-md: 110px;

.event-list-item-match {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: $sp4;

	body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
		color: var(--color-black);
	}

	@include size(md-up) {
		flex-grow: 1;
		gap: $sp4;
	}
}

.event-list-item-match__team {
	@include font-size(fs-80);
	display: flex;
	min-width: 0;
	width: calc(100% / 2 - #{$result-width});
	align-items: center;
	gap: $sp3;

	&.-home {
		justify-content: flex-end;
	}

	&.-guest {
		justify-content: flex-start;
	}

	@include size(md-up) {
		width: calc(100% / 2 - #{$result-width-md});
	}
}

.event-list-item-match__team-name {
	min-width: 0;

	&.-full {
		display: none;

		@include size(md-up) {
			@include line-clamp(2);
		}
	}

	&.-short {
		@include line-clamp(2);

		@include size(md-up) {
			display: none;
		}
	}
}

.event-list-item-match__team-logo {
	width: 24px;
	flex-shrink: 0;

	@include size(md-up) {
		width: 40px;
	}
}

.event-list-item-match__score {
	@include font(primary, medium, normal, fs-150);
	width: $result-width;
	text-align: center;

	@include size(md-up) {
		width: $result-width-md;
	}
}

.event-list-item-match__score-divider-space {
	position: relative;
	display: inline-block;
	width: 0.1em;
}

.event-list-item-match__score-extra {
	&::after {
		@include font(primary, book, normal, fs-60);
		position: absolute;
		margin-left: $sp2;
		color: var(--color-grey-300);
		content: attr(data-extra);
		line-height: inherit;
	}
}
</style>
